if (!customElements.get("footer-section")) {
  customElements.define(
    "footer-section",
    class FooterSection extends HTMLElement {
      constructor() {
        super();
      }
      toggleMenu(event) {
        const button = event.currentTarget;
        const content = button.nextElementSibling;
        const icon = button.querySelector("svg");
        if (content && content.matches("[data-footer-menu-link-content]")) {
          content.classList.toggle("opacity-0");
          content.classList.toggle("h-0");
          content.classList.toggle("overflow-hidden");
        }
        if (icon) {
          icon.classList.toggle("rotate-90");
          icon.classList.toggle("-rotate-90");
        }
      }
      setupToggleButtons() {
        const toggleButtons = this.querySelectorAll("[data-footer-menu-link-toggle]");
        toggleButtons.forEach((button) => {
          button.addEventListener("click", this.toggleMenu.bind(this));
        });
      }
      init() {
        this.setupToggleButtons();
      }
      // Lifecycle callback when the element is connected to the DOM
      connectedCallback() {
        this.init();
      }
    }
  );
}
